import { t } from 'i18next';

import { religousCapitalization, templateString } from './bioKeys.tsx';

export const listFormat = (items?: string[]) => {
  if (t('bio:localeFormat') === 'ko') {
    return items?.map((item) => t(templateString('bio:', item)))?.join(', ');
  }

  const formatter = new Intl.ListFormat(t('bio:localeFormat'), {
    style: 'long',
    type: 'conjunction',
  });
  return formatter.format(
    items?.map((item) =>
      religousCapitalization(t(templateString('bio:', item))),
    ) as Iterable<string>,
  );
};
